import { Button, Stack, Typography } from '@mui/material'

import { Dialog, PhxIcon } from '@salsita-ai/platform-project-sdk/ui'

import { JobDetailsForm } from '../shared/JobDetailsForm'
import { type FinalizationFormData } from '../shared/JobDetailsForm'

const BULK_FORM_ID = 'bulk-finalize-form'

interface BulkPlateJobDetailsDialogProps {
  onBack: () => void
  onNext: (data: FinalizationFormData) => void
}

export const BulkPlateJobDetailsDialog = (props: BulkPlateJobDetailsDialogProps) => {
  const { onBack, onNext } = props

  const handleFormSubmit = (data: FinalizationFormData) => {
    onNext(data)
  }

  return (
    <Dialog.Root variant="static" sx={{ width: '90%', maxWidth: '1000px' }}>
      <Dialog.ContentLayout
        controlsPosition="end"
        body={<JobDetailsForm onSubmit={handleFormSubmit} formId={BULK_FORM_ID} disableQuoteLineEdit />}
        controls={
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
            <Typography variant="body2" color="secondary">
              Step 1 of 2
            </Typography>
            <Stack direction="row" gap={1}>
              <Button variant="text" onClick={onBack} startIcon={<PhxIcon name="ArrowLeft" />}>
                Back to Summary
              </Button>

              <Button variant="contained" endIcon={<PhxIcon name="ArrowRight" />} form={BULK_FORM_ID} type="submit">
                Next
              </Button>
            </Stack>
          </Stack>
        }
      />
    </Dialog.Root>
  )
}
